import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col, Dropdown, MenuItem } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import LoadingBar from 'components/atoms/LoadingBar';
import styled, { withTheme } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import moment from 'moment';
import DatePickerContainer from 'containers/DatePickerContainer';
import { setTimeRangeByKey, setObjectiveShadow } from 'services/config/duck';
import { fetchMeta as fetchEntityMeta } from 'services/entities/duck';
import EntityDropdownContainer from 'containers/EntityDropdownContainer';
import printLogo from 'assets/ggLogoPrint_black.png';
import TrackedComponentEnhancer from 'hoc/TrackedComponent';

const TrackedDropdown = TrackedComponentEnhancer({
    trackedName: 'Dropdown-DatePicker-Styled',
    targetComponent: Dropdown
});

const TrackedMenuItem = TrackedComponentEnhancer({
    trackedName: 'TitleContainer-DatePicker-Menu-Item',
    targetComponent: MenuItem
});
const TrackedStyledDropdown = styled(TrackedDropdown)`
    margin: 8px 5px 0 2px;

    #date-dropdown {
        border-radius: 0;
        background: #fff;
        font-size: 12px;
        text-transform: uppercase;
        border: 1px solid ${props => props.theme.colors.secondary};
    }

    #date-dropdown[aria-expanded="true"] {
        border: 1px solid ${props => props.theme.colors.primary};
    }

    .menu-item {
        font-size: 12px;
    }

    &[disabled] {
        opacity: 0.5;
        cursor: default;
    };

    ${breakpoint('xs', 'md')`
        margin-bottom: 5px;
    `}
`;


const FlexCol = styled(Col)`
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
        height: 40px;
        margin-top: 10px;
    }

    h2 {
        margin-left: 10px;
        flex-grow: 1;
        font-size: 16px;
    }

    h3 {
        font-size: 16px;
        text-align: right;
    }
`;

const TitleWrapper = styled.div`
    margin-top: 70px;
    position: ${props => (props.admin ? 'static' : 'fixed')};
    z-index: 1001;
    background-color: #fff;
    border-bottom: ${props => props.theme.global.borders.layout};
    text-transform: uppercase;

    ${breakpoint('xs', 'md')`
        margin-top: 60px;
        margin-bottom: 10px;
    `}

    ${props => !props.admin && breakpoint('xs', 'md')`
        width: 100%;
        position: static;
    `}

    ${props => !props.admin && breakpoint('md', 'xl')`
        width:calc(100% - 200px);
    `}

    @media print {
        margin-top: 0;
    }
`;

const DatePickerWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 75px;
    ${breakpoint('xs', 'md')`
        justify-content: center;
        height: 60px;
    `}
`;

const EntityWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    height: 75px;  
    ${breakpoint('xs', 'md')`
        justify-content: center;
        height: 60px;
    `} 
`;

class TitleContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.setFocusOnFrom = this.setFocusOnFrom.bind(this);
        this.createAdditionalMenuItemProps = this.createAdditionalMenuItemProps.bind(this);
    }

    setFocusOnFrom() {
        document.querySelector('.InputFromTo-from input').focus();
    }

    createAdditionalMenuItemProps(key) {
        if (key === 'this-month') {
            const disabled = moment().startOf('day').isSame(moment().startOf('month'));
            return {
                disabled,
                title: disabled ? 'No data available for this date range' : ''
            };
        }
        return {};
    }

    render() {
        const selectedTimeRange = this.props.selectedTimeRange;
        const timeRanges = this.props.timeRanges;
        const startDate = moment(new Date(this.props.selectedTimeRange.apiConfig.start())).format('MM/DD/YYYY');
        const endDate = moment(new Date(this.props.selectedTimeRange.apiConfig.end())).format('MM/DD/YYYY');
        return (
            <TitleWrapper admin={this.props.admin}>
                <Grid fluid style={this.props.admin ? { margin: '0 25px' } : {}}>
                    <Row className="hidden-print">
                        <Col sm={12} md={5} lg={6}>
                            <EntityWrapper>
                                <EntityDropdownContainer
                                    admin={this.props.admin}
                                    title={this.props.title} />
                            </EntityWrapper>
                        </Col>

                        <Col sm={12} md={7} lg={6}>
                            {!this.props.hideDatePicker &&
                                <DatePickerWrapper>
                                    <TrackedStyledDropdown
                                        key={1}
                                        id='date-dropdown' >
                                        <Dropdown.Toggle>{selectedTimeRange.label}</Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {Object.keys(timeRanges).map(k =>
                                                <TrackedMenuItem
                                                    {...this.createAdditionalMenuItemProps(k)}
                                                    key={k}
                                                    eventKey={k}
                                                    className={`menu-item key-${k}`}
                                                    active={selectedTimeRange.key === timeRanges[k].key}
                                                    onSelect={k === 'custom-range' ? () => this.setFocusOnFrom() : () => this.props.setTimeRangeByKey(k)} >
                                                    {timeRanges[k].label}
                                                </TrackedMenuItem>
                                            )}
                                        </Dropdown.Menu>
                                    </TrackedStyledDropdown>
                                    <DatePickerContainer
                                        entityId={this.props.entityId}
                                        pageRange={this.props.pageRange} />
                                </DatePickerWrapper>}
                        </Col>
                    </Row>
                    <Row className="visible-print-block">
                        <FlexCol xs={12}>
                            {get(this.props.theme, 'whitelabel.showGGBranding', true) ? <img src={printLogo} alt="Goodway Group" /> : null}
                            <h2>{this.props.entityMeta.name}</h2>
                            <h3>{startDate}&nbsp;- {endDate}</h3>
                        </FlexCol>
                    </Row>
                </Grid>
                <LoadingBar />
            </TitleWrapper>

        );
    }
}

TitleContainer.propTypes = {
    hideDatePicker: PropTypes.bool,
    entityId: PropTypes.number
};

const mapStateToProps = (state, ownProps) => ({
    location: state.router.location,
    entityMeta: state.entities.meta,
    selectedTimeRange: state.config.selectedTimeRange,
    timeRanges: ownProps.timeRanges || state.config.timeRanges,
    currentUser: state.users.currentUser
});

export default connect(mapStateToProps,
    { setTimeRangeByKey, setObjectiveShadow, fetchEntityMeta })(withTheme(TitleContainer));



// WEBPACK FOOTER //
// ./src/containers/TitleContainer.js